import type {ReactNode} from 'react';
import {BookUser, Car, IdCard} from 'lucide-react';
import {isDrivingLicenseDocType, isPassportDocType} from '@chekin/core';

function getDocumentTypeIcon(value: string): ReactNode {
  if (isPassportDocType(value)) return <BookUser />;
  if (isDrivingLicenseDocType(value)) return <Car />;
  return <IdCard />;
}

export {getDocumentTypeIcon};
